<div mat-dialog-title class="flex">
  <h2>{{title}}</h2>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content [formGroup]="form">

        <div class="row">
            <mat-form-field class="col-md-4">
                <mat-label>For Rent</mat-label>
                <mat-select formControlName="isAvailable" required>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-4">
                <input matInput placeholder="Owner Name" name="ownerName" formControlName="ownerName" required>
            </mat-form-field>

            <mat-form-field class="col-md-4">
                <input matInput placeholder="Manager Name" formControlName="managerName" required>
            </mat-form-field>

            <mat-form-field class="col-md-4">
                <input matInput placeholder="Contact Phone #" formControlName="contactPhone" required>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-12">
                <input matInput placeholder="Email" name="email" formControlName="email" required>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-12">
                <input matInput placeholder="Address" formControlName="address" required>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-8">
                <input matInput placeholder="City" formControlName="city" required>
            </mat-form-field>
            <mat-form-field class="col-md-4">
                <input matInput placeholder="ZipCode" formControlName="zipCode" required>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-4">
                <input matInput placeholder="Building Number" formControlName="buildingNumber">
            </mat-form-field>

            <mat-form-field class="col-md-4">
                <input matInput placeholder="# of Units in Building" formControlName="buildingUnits">
            </mat-form-field>

            <mat-form-field class="col-md-4">
                <input matInput placeholder="Available Units" formControlName="availableUnits">
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-12">
                <input matInput placeholder="Property Note" formControlName="propertyNote">
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-8">
                <mat-label>Housing Vouchers Acceptance</mat-label>
                <mat-select formControlName="hcvCheck" required>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-md-12">
                <input matInput placeholder="Voucher Note" formControlName="hcvNote">
            </mat-form-field>
        </div>

        <div class="row">
            <mat-checkbox color="primary" matInput formControlName="buildingAdaAccessible">Building ADA Accessible</mat-checkbox>
        </div>

        <div class="row">
            <mat-checkbox color="primary" matInput formControlName="unitAdaAccessible">Unit ADA Accessible</mat-checkbox>
        </div>

        <div class="row">
            <mat-form-field class="col-md-12">
                <input matInput placeholder="Accessible Note" formControlName="accessibleNote">
            </mat-form-field>
        </div>

        <div class="row">
          <mat-checkbox color="primary" matInput formControlName="incentiveForRentwise">Incentive for Rentwise</mat-checkbox>
        </div>

        <div class="row">
            <mat-form-field class="col-md-12">
                <input matInput placeholder="Incentive Note" formControlName="incentiveNote">
            </mat-form-field>
        </div>

        <div class="mb-2">
          <button class="mat-raised-button" (click)="close()">Close</button>
          <button type="submit" class="mat-raised-button mat-primary ml-2" [disabled]="form.invalid" (click)="save()">Save</button>
        </div>

    </mat-dialog-content>
